<template>
  <ul class="select-seats">
    <li class="select-item" v-for="seat in selectedSeats" :key="seat.offerSeatId" @click="onCancelSelectSeat(seat)">
      <div class="seat-name">{{ `${seat.rowId}排${seat.columnId}座` }}</div>
      <div>
        <decimal-price :price="seat.seatPrice" unitSize="8px" intergeSize="13px" decimalSize="13px" :mystyle="{color: '#FAB646', 'margin-left': '-2px'}" />
      </div>
      <img class="icon-delete" :src="iconCancel" alt />
    </li>
  </ul>
</template>

<script>
import DecimalPrice from '@comp/decimal-price'

export default {
  name: 'SelectSeats',
  components: {
    'decimal-price': DecimalPrice,
  },
  props: {
    selectedSeats: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      iconCancel: require('@img/schedule/icon_delete@2x.png'),
    }
  },
  methods: {
    onCancelSelectSeat(seat) {
      this.$emit('cancelSeat', seat)
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
.select-seats {
  position: relative;
  display: flex;
  padding: 10px 0;
  overflow-x: scroll;

  &::after {
    .setTopLine();
  }

  .line {
    margin: 0 15px;
    height: 1px;
    background-color: #ededed;
  }

  .select-item {
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    background-color: rgba(244, 244, 244, 0.6);
    border-radius: 2px;
    padding: 4px 25px 4px 10px;
    margin-right: 15px;
  }

  .seat-name {
    font-size: 14px;
    color: #191a1b;
  }

  .icon-delete {
    position: absolute;
    bottom: 6px;
    right: 5px;
    width: 15px;
    height: 15px;
  }
}
</style>



